/**
 * Debug logging flag — shared by Data.isDebug and BasicInfo.isDebug.
 *
 * On by default under `npm start` (CRA sets NODE_ENV=development).
 * Off in production builds unless REACT_APP_DEBUG=true is set at build time.
 */
export const isDebug =
  process.env.REACT_APP_DEBUG === "true" ||
  process.env.NODE_ENV === "development";

export default isDebug;
